import type { AudioEventMapping } from "../banks/types";

/**
 * Universal event → soundId mappings. Only events that every slot game
 * raises regardless of mechanic or feature set. Mechanic-specific events
 * (grid.column_drop, grid.remove_symbols) and game-specific feature events
 * (grid.scatter_*, grid.multiplier_*, grid.win_highlight) live in each
 * game's `createGameAudioOverrides().mapping`.
 */
const DefaultAudioMapping: AudioEventMapping = {
  "ui.click": "ui_click",

  "spin.start": "spin_start",
  "spin.slam": "spin_slam",

  "bet.increase": "bet_increase",
  "bet.decrease": "bet_decrease",

  "bigwin.start": "bigwin_start",
  "bigwin.count_start": "bigwin_count_start",
  "bigwin.count_end": "bigwin_count_end",
  "bigwin.end": "bigwin_end",
};

/**
 * The mapping a session resolves events through: the shell's defaults overlaid by the game's
 * `GameAudioOverrides.mapping`, the game's sound winning an event both name. The one merge: the audio
 * service plays by it and the dev recorder logs by it, so the e2e audio log names the sound the service resolved.
 */
export function mergeAudioMapping(gameMapping: AudioEventMapping | undefined): AudioEventMapping {
  return { ...DefaultAudioMapping, ...gameMapping };
}